import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import ac849ae493f267dc247e3fc83e6f74b51b from "./generated-153aef1a-cb3c-45a9-b8ea-43b989fc2f3f.json";

import acde414a8006eb5acf980bee7b60fa70bb from "./generated-b13f8c6c-3081-4e87-9951-aa1ab64f5368.json";

import a27258943d1481f76543c3683663a7809b from "./generated-4f63693e-874f-4e50-845c-c0675398f95b.json";

import aea26b41a1987b00a32f25b7d0628e3cbb from "./generated-1d6e4780-5d78-4d0b-b633-71dd0fb30a5d.json";

import a06c11c23e7a051c0cd4f4fa657389780b from "./generated-94ba3662-a3ab-455a-8c70-7b9a6f3eec41.json";

import aeb1435661df26d20b9a183d5bb94f9fdb from "./generated-cb5127a2-7f2d-46c1-8605-a572000c3873.json";

import a4a8edff2573d6b835980c30ed2325050b from "./generated-137d4fef-f1c9-4f63-9b3d-bd90007fad8c.json";

import add50a6344e4c715875f2b5fb9ca7a6dbb from "./generated-73dafe9b-9669-4530-a40b-f80de1ff3e51.json";

import a2aed36fa80af99fabc2eae7e39e29c43b from "./generated-41a4b6e7-0c35-43e9-aa4c-6ed98d0322aa.json";

import abc1c484b8da27b4f569ce868a7c106e6b from "./generated-f0b71961-25be-492c-b8e6-291329e5d5e4.json";

import a0e14d15d306b4afcf8a3f20ce35fcc0db from "./generated-263e8cc7-2792-4dea-9867-9de14596c981.json";

import a9aa0689868520f2304da9bc70b17d76fb from "./generated-69be2461-263e-4067-bb11-7409c9d6abca.json";

import a1d16f11d0531c5617ca3989a0eae9338b from "./generated-796887e5-b1a6-4306-965e-67c7fbda7aed.json";

import ac584c60193271689eb4c45373efa320cb from "./generated-a84ec63f-3b22-434b-b70c-077cf982d6cb.json";

import a69e3ab3f0b00436b359b61db75a0cdcdb from "./generated-3c83b7d2-2c80-4d1a-888d-1370821dbf44.json";

import aa6110f14cd102026600821ce7507e68eb from "./generated-3710fa1b-baf0-431c-9a4b-87a3fa14f474.json";

import af3dbbb20b4eb022d865713074b345de4b from "./generated-556efc55-9c1b-41b0-85a6-77b0244b30d8.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(ac849ae493f267dc247e3fc83e6f74b51b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(acde414a8006eb5acf980bee7b60fa70bb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a27258943d1481f76543c3683663a7809b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(aea26b41a1987b00a32f25b7d0628e3cbb);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a06c11c23e7a051c0cd4f4fa657389780b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(aeb1435661df26d20b9a183d5bb94f9fdb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a4a8edff2573d6b835980c30ed2325050b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(add50a6344e4c715875f2b5fb9ca7a6dbb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a2aed36fa80af99fabc2eae7e39e29c43b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(abc1c484b8da27b4f569ce868a7c106e6b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a0e14d15d306b4afcf8a3f20ce35fcc0db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a9aa0689868520f2304da9bc70b17d76fb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a2aed36fa80af99fabc2eae7e39e29c43b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a1d16f11d0531c5617ca3989a0eae9338b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(ac584c60193271689eb4c45373efa320cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a2aed36fa80af99fabc2eae7e39e29c43b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a69e3ab3f0b00436b359b61db75a0cdcdb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(aa6110f14cd102026600821ce7507e68eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(af3dbbb20b4eb022d865713074b345de4b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a69e3ab3f0b00436b359b61db75a0cdcdb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */